import React, { memo } from 'react'
import type { PropsWithChildren } from 'react'
import Text from 'react-font'

import Title from './Title'
import './Title.module.css'

export interface ContentProps {
  title: string
  id: string
}

const Content: React.FC<PropsWithChildren<ContentProps>> = memo(
  ({ children, title, id }) => {
    return (
      <div
        id={id}
        className="mx-4 md:container md:mx-auto bg-brand-sand border-dashed border-2 border-brand-sage rounded-xl"
      >
        <Title>{title}</Title>
        {/* text-align:justify isn't set here even though this section can
            hold flowing prose — it cascades onto every text node inside
            `children`, including ServiceCard titles/grids, and stretches
            multi-word titles into ugly justified gaps on narrow screens.
            Apply text-justify at the call site for prose-only sections. */}
        <div className="p-6 text-brand-taupe text-lg">
          <Text family="Nunito">
            <span>{children}</span>
          </Text>
        </div>
      </div>
    )
  },
)
Content.displayName = 'Title'

export default Content
